/**
 * Shared Agency Fees defaults by operation.job_scope (Services step + AgencyFees panel).
 * Keys must stay aligned with JobDetails jobScopes; Owner's may use ASCII or typographic apostrophe.
 */

/** Card name in `cards` table used as default supplier for Agency Fees (resolved via API). */
export const SINODA_AGENCY_FEES_CARD_NAME = 'Sinoda';

let sinodaCardIdPromise = null;

export function fetchSinodaAgencyFeesCardId(api) {
  if (!sinodaCardIdPromise) {
    sinodaCardIdPromise = api.cards
      .index('', SINODA_AGENCY_FEES_CARD_NAME)
      .then((res) => {
        const list = res.cards || [];
        const first = list[0];
        return first != null && first.id != null ? Number(first.id) : null;
      })
      .catch(() => null);
  }
  return sinodaCardIdPromise;
}

export function normalizeJobScope(scope) {
  if (scope == null || scope === '') return '';
  return String(scope).replace(/\u2019/g, "'").trim();
}

/** @returns {number|null} */
export function agencyFeesAmountForJobScope(jobScope) {
  const key = normalizeJobScope(jobScope);
  if (!key) return null;
  const amounts = {
    "Owner's Matter": 350,
    'Charterer': 350,
    'Cargo Operation': 1500,
    'Handover / takeover': 150,
    'Full Agent': 500,
    'OPL(outside port limits)': 350,
    'Shipyard / Dry Dock': 500,
    'Sheriff Agent': 500,
    'Crew Service': 500,
  };
  return Object.prototype.hasOwnProperty.call(amounts, key) ? amounts[key] : null;
}

export function pickAgencyFeesCardId(suppliers, preferredId = null) {
  if (!suppliers || !suppliers.length) return null;
  if (preferredId != null && suppliers.some((s) => s.id === preferredId)) return preferredId;
  return suppliers[0].id;
}
